import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createUser, getUser, signIn, getDriveit } from "../api/api";
import myinventoryIcone from '../assets/myinventory-icone.svg';
import atos from "../assets/atos-logo.svg";
import "../styles/Buttons.css";
import "../styles/Alinhamento.css";
import "../styles/Texts.css";
import "../styles/Login.css";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");  
  useEffect(() => {
    const savedUserData = localStorage.getItem('user');

    if (savedUserData) {
      try {
        const parsed = JSON.parse(savedUserData);
        const agora = new Date().getTime();
        const umDia = 24 * 60 * 60 * 1000;

        if (!parsed.timestamp) {
          
          localStorage.removeItem('user');
        } else if (agora - parsed.timestamp < umDia) {
          
          navigate("/OpcoesDeAcesso", { state: { user: parsed.user } });
          return;
        } else {
          
          localStorage.removeItem('user');
        }
      } catch (e) {
        
        localStorage.removeItem('user');
      }
    }

    localStorage.removeItem('equipamentosR');
    
  }, []);

  const fetchdriveit = async () => {        
    const response = await getDriveit();        
    const equipamento = response.map((r) => ({
        ...r.fields,
        pk: r.pk
    }));    
    localStorage.setItem('equipamentos', JSON.stringify(equipamento));    
  };

  const handleLogin = async () => {
    try {
      let user = await signIn(email, password)      
      if (user && user.access) {
        fetchdriveit();
        const userData = {
          user: email,
          timestamp: new Date().getTime()
        };
        localStorage.setItem('user', JSON.stringify(userData));
              
        navigate("/OpcoesDeAcesso", { state: { user: email } });
      } else {        
        alert('Usuário ou senha incorretos, tente novamente por favor');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <body>
        <header>
        <img src={myinventoryIcone} alt="logo myinventory" className='myinventory-icone' />
        </header>
        <main>
          <div className="conteudo-principal">
            <p className="texto-principal-da-pagina">Acesse sua conta</p>
            <form
              style={{
                display: "flex",
                position: "relative",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              <input
                className="input-login"
                type="text"
                id="nickName"
                placeholder="  Insira seu usuário"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                className="input-login"
                type="password"
                id="password"
                placeholder="  Insira sua senha"                
                secureTextEntry
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="botoes-alinhamento">
                <button className="button-1-claro" type="submit">
                  Entrar
                </button>
              </div>
            </form>
          </div>
          <footer>
            <img
              src={atos}
              className="footer-alinhamento-fixed Atos-logo"
              alt="logo atos"
            ></img>
          </footer>
        </main>
      </body>
    </React.Fragment>
  );
}

export default Login;
